export default __webpack_public_path__ + "865ab832343f21e28f978db442bd9acc.png";